export const GOT_PRESS_RELEASE = 'got-press-release';
const gotPressRelease = ({ release }) => ({
  type: GOT_PRESS_RELEASE,
  payload: { release },
});
export default gotPressRelease;
